export default __webpack_public_path__ + "static/media/icon-ranking-1.efeab50a.svg";